export default {
    GiveAwayAPI_URL: 'https://api-loyalty.wfiws-prd.eu-west-1.aws.pmicloud.biz',
    Tools_Env: 'prd',
    SSO_CallbackUrl: 'https://ems-bo.wfiws-prd.eu-west-1.aws.pmicloud.biz/login',
    CognitoCustomDomain: 'https://wfiws-prd-ems.auth.eu-west-1.amazoncognito.com'
}